import { observeElement } from '@uvocore-front/utils';
import PerfomanceSlider from '../../components/PerfomanceSlider';
import './style.scss';

const testimonialsSlider = () => {
  if (document.querySelector('.testimonials-section')) {
    observeElement({
      element: '.testimonials-section',
      marginValue: 200,
      callback: () => {
        new PerfomanceSlider({ // eslint-disable-line
          selector: document.querySelector('.testimonials'),
          margin: 0,
          itemWidth: 330,
          isSetNavButtonsPosition: false,
          isHideNav: true,
        });
      },
    });
  }
};

if (document.querySelector('.testimonials')) {
  observeElement({
    element: '.testimonials',
    marginValue: 200,
    callback: () => {
      if (document.readyState === 'complete') {
        testimonialsSlider();
      } else {
        window.addEventListener('load', testimonialsSlider);
      }
    },
  });
}
